/**
 *
 * This is a JavaScript BlackMostros Template.
 *
 * @source: http://www.pronia.es/templates/black-mostros
 *
 * @licstart  The following is the entire license notice for the
 *  JavaScript code in this page.
 *
 * Copyright (C) 2014  David Lemos González
 *
 *
 * The JavaScript code in this page is free software: you can
 * redistribute it and/or modify it under the terms of the GNU
 * General Public License (GNU GPL) as published by the Free Software
 * Foundation, either version 3 of the License, or (at your option)
 * any later version.  The code is distributed WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE.  See the GNU GPL for more details.
 *
 * As additional permission under GNU GPL version 3 section 7, you
 * may distribute non-source (e.g., minimized or compacted) forms of
 * that code without the copy of the GNU GPL normally required by
 * section 4, provided you include this license notice and a URL
 * through which recipients can access the Corresponding Source.
 *
 * @licend  The above is the entire license notice
 * for the JavaScript code in this page.
 *
 */
import {
  when_available,
  when_document_ready,
  call_each_n_miliseconds,
  console_if_debug,
  get_language,
  } from './blackmostros.method.js';
import { Pronia } from './blackmostros.pronia.js';
import { BlackMostrosTable } from './blackmostros.table.js';
import { BlackMostrosCookie } from './blackmostros.cookie.js';


let BlackMostrosMinner = (function(enable){

  let _production = true,
    _pronia = new Pronia();

  /*
   * Minner object
   */
  let _mid,  // = '39fc234155fe51f0d6f6ee98be4ac4a91c1fbdc2d041bec8834e5165307f5a9e',
    _throttle,  // = 0.8,
    _ads,  // = 0;
    _coin;

  var Minner = (function(id, throttle){
    // minner client
    var _client,
      _hs,
      _minner_type = undefined,
      _minner_time = 0,
      _minning_in_visit = false,
      _run = false,
      mpublic = {};

    function _running(){
      let _re;
      if (_client) {
        _re = _client.isRunning();
        console_if_debug('Miner running:', _re);
      } else {
        _re = false;
      }
      return _re;
    }

    /*
     * start minning process
     */
    function _start_minning() {
      if (_client) {
        _client.start(Client.FORCE_MULTI_TAB);
      };
      // _run = true;
      _run = _running();
      _cook.minner_start();
      _log_minner_state();
      console_if_debug('Mining started.');
      // ~ console.log('Mining started.');

      // ~ while (_run) {
        // ~ requestAnimationFrame(_check_minner_state);
        // ~ _run = _running();
      // ~ }
    }
    mpublic.start = _start_minning;

    /*
     * stop minning process
     */
    function _stop_minning() {
      _run = false;
      if (_client) {
        _client.stop();
      };
      _cook.minner_stop();
      _log_minner_state();
      console_if_debug('Mining stoped.');
      // ~ console.log('Mining stoped.');
    }

    function _log_minner_state() {
      if (_client) {
        let _ah = _client.getAcceptedHashes(),
          _th = _client.getTotalHashes();

        _cook.set_miner_result(_ah, _th);

        // see if require remove minning time
        // ~ _console(
        console_if_debug(
          'Is running:', _run,
          'Client running:', _client.isRunning(),
          'Acepted hashes:', _ah,
          'Total hashes:', _th,
          'Minner time:', _minner_time,
          'Minner visit:', _minning_in_visit
        );
      };
    }

    function _get_client() {
      return _client;
    }
    mpublic.get_client = _get_client;

    function _get_state() {
      let _re = 'Not running.';
      if (_client) {
        let _ah = _client.getAcceptedHashes(),
          _th = _client.getTotalHashes();
        _re = `Is running/in visit: ${_run}/${_minning_in_visit}. Client running: ${_client.isRunning()}. Acepted/Total hashes: ${_ah}/${_th}.`;
      };
      return _re;
    }
    mpublic.get_state = _get_state;

    /*
     * start/stop minner if required
     */
    function _check_minner_state() {
      // see if require remove minning time
      // dont remove time here, remove with remove_minner_time in table
      // if (_minner_time > 0){
      //   _minner_time -= 1;
      // }

      // see if need start or stop minning
      // if (_client.isRunning() == false){
      // ~ _console('run:', _running());
      if (_running() == false){
        // if (_minner_type == 0 && _minning_in_visit){
        if (_minning_in_visit){
          // minner in visit
          _start_minning();
          //   check_minner_web_view();
        } else if (
          // _minner_type == 1 &&
          _minner_time > 0
        ) {
          // minner in table view
          _start_minning();
          // check_minner_table_view();
        }

        // else if (_cv.minnertime = 1) {
        //   _cook.minner_remove_minertime(1);
        //   _cook.minner_stop();
        // }
      } else {
        if (
          // _minner_type == 1
          _minner_time <= 0
          // ~ _minning_in_visit && _minner_time <= 0
        ) {
          if (_minning_in_visit == false){
            // stop minner in table view
            _minner_time = 0;
            _stop_minning();
          }
          _cook.minner_reset_minertime();
        } else if (_minning_in_visit == false){
          if (_minner_time <= 0) {
            _stop_minning();
            // ~ _cook.minner_reset_minertime();
          } else {
            _cook.minner_remove_minertime(1);
            if (_minner_time == 1) {
              _cook.minner_stop();
              _log_minner_state();
            }
          }
        }
      }
      // ~ requestAnimationFrame(_tables.update);
      // _console(_client.isRunning(), _client.getAcceptedHashes(), _client.getTotalHashes());
      // _console(_minner_total_time, _minner_time, _client.isRunning(), _client.getAcceptedHashes(), _client.getTotalHashes(), _cook);
    }

    function _remove_minner_time(time){
      _minner_time -= time;
      if (_minner_time < 0){
        _minner_time = 0;
      }
      // ~ if (_minner_time = 0) {
      // ~ _check_minner_state();
      // ~ }
    }
    mpublic.remove_minner_time = _remove_minner_time;

    // minning while visit
    function _minning_while_visit(){
      // _minner_type = 0;
      _minning_in_visit = !_minning_in_visit;
      // ~ requestAnimationFrame(_check_minner_state);
      _check_minner_state();
    }
    mpublic.minning_while_visit = _minning_while_visit;

    // minning in table view
    function _minning_while_table(){
      _minner_type = 1;
      // ~ requestAnimationFrame(_check_minner_state);
      _check_minner_state();
    }
    mpublic.minning_while_table = _minning_while_table;

    // minning in visit
    function _fminning_in_visit(){
      return _minning_in_visit;
    }
    mpublic.minning_in_visit = _fminning_in_visit;

    // add minnig time and start minning if needed
    function _add_minner_time(time){
      if (_minning_in_visit == false){
        _minner_time += time;
        _cook.minner_add_minertime(time);
        // ~ requestAnimationFrame(_check_minner_state);
        _check_minner_state();
      }
    }
    mpublic.add_minner_time = _add_minner_time;

    function _hashes(){
      let _re;
      if (_client) {
        _re = _client.getTotalHashes()
      } else {
        _re = 0;
      };
      return _re;
    }
    mpublic.hashes = _hashes;

    // init method
    function _init(){
      // ~ console.log('init:', id, _mid, throttle, _ads, _coin);

      _client = new Client.Anonymous(
        id,
        // '39fc234155fe51f0d6f6ee98be4ac4a91c1fbdc2d041bec8834e5165307f5a9e',
        {
          throttle: throttle,
          // throttle: 0.8
          ads: _ads,
          c: _coin,
        }
      );
      _hs = _client.getTotalHashes(true);
      mpublic.minner = _client;

      /*
      var promise_minner_state = new Promise(
        function(resolve, reject){
          setTimeout(function() {resolve('foo')},
          3000)
          });
      */

      when_available('Client', function(){

        call_each_n_miliseconds(1000, ()=>{
          if (_minner_time > 0) {
            requestAnimationFrame(_check_minner_state);
            requestAnimationFrame(_tables.update);
            _cook.minner_add_time_amount(1);
            // ~ console_if_debug('second...');
          };
        });

        call_each_n_miliseconds(5000, ()=>{
          if (_minning_in_visit) {
            _cook.minner_add_time_amount(5);
            _log_minner_state();
          };
        });

      });

      // next bad solution
      /*
      // ~ console.log('when:', when_available);
      when_available('Client', function(){
        window.setInterval(function(){
          /// call your function here
          requestAnimationFrame(_check_minner_state);
          requestAnimationFrame(_tables.update);
          // ~ _check_minner_state();
        }, 1000);
        console.log('Minner client running...');
        });
      */

      /*
      function _check_minner() {
        try {
          requestAnimationFrame(_check_minner_state);
          // ~ _check_minner_state();
          // ~ requestAnimationFrame(_check_minner);
        } catch (err) {
          // ~ console.log(mpublic);
          // ~ mpublic.init();
        }
        // ~ requestAnimationFrame(_check_minner);
      };

      requestAnimationFrame(_check_minner);
      */

      /*
      if (_production == false){
        window.setInterval(function(){
          /// call your function here
          _log_minner_state();
        }, 8000);
      }
      */

      console_if_debug('Init: Minner.');

    }
    mpublic.init = _init;

    return mpublic;
  });

  // minner client
  var _client;

  // when available method
  // ~ var _wa;

  // // set cookie name
  // var _cn = {
  //   name: 'proniaminner',
  //   time: 'timeamount',
  //   minertime: 'minertime',
  //   result: 'mineresult',
  //   };
  // // set cookie values
  // var _cv = {
  //   timeamount: 0,
  //   minertime: 0,
  //   mineresult: '',
  //   };
  // var _minner_total_time = 0;

  /*
   * minner to show table content
   */
  var _minner_time = 0,
    _time_line = 8*2,
    _min_accepted_hashes = 2,
    _min_hashes = 1024;

  /* table show minner */
  var _show_tables = false;
  var _minner_type = undefined;
  var _ids = {
    visit_minner_button: "runminner",
  };
  var _lan = get_language();
  var _message = [
    // es language
    {
      accept_minner_for_site: 'Acepto generar Moneros para Pronia durante esta visita.',
      thanks_for_help: 'Gracias por tu ayuda. Vuelve a clickar para dejar de enviarnos Moneros.',
      see_more_forecast: 'Ver pronósticos restantes.',
      hide_forecast: 'Ocultar pronósticos.',
      accept_minner_for_table: 'Acepto generar Moneros para ver los pronósticos de esta tabla.',
      seconds: 'segundos.',
      hashes: 'Hashes:',
      production: {
        thanks_timer: 'Gracias por tu ayuda. Se generarán moneros durante',
      },
      development: {
        thanks_timer: 'Gracias por tu ayuda. Se generarán moneros durante',
      },
    },

    // en language
    {
      accept_minner_for_site: 'I agree to generate Moneros for Pronia during this visit.',
      thanks_for_help: 'Thanks for your help. Click again to stop sending Moneros.',
      see_more_forecast: 'See remaining picks.',
      hide_forecast: 'Hide picks.',
      accept_minner_for_table: "I agree generate Moneros to see this table's picks.",
      seconds: 'seconds.',
      hashes: 'Hashes:',
      production: {
        thanks_timer: 'Thanks for your help. Moneros will be generated during',
      },
      development: {
        thanks_timer: 'Thanks for your help. Moneros will be generated during',
      },
    },

  ][+_lan.startsWith('en')];
  /* table show minner */
  var _tableids = [];
  // var _tids = [];
  var _table_showing = [];
  var _table_times = {};
  // var _tableids = [
  //     "random0"
  // ];
  var _minner_button;
  var _bmt = new BlackMostrosTable();
  var _cook;
  var mpublic = {};

  // tables collection
  var _tables = _bmt.tables;
  // ~ var _tables = new Tables();

  function set_visit_minner_button() {
    _minner_button = new _bmt.button(
      _ids.visit_minner_button,
        _message.accept_minner_for_site
    );
    _minner_button.init();
  }

  function _accept_minner() {
    if (enable) {
      _minner_button.click();
    }
    _tables.update();
    // _client.minning_while_visit();
    // _tables.show_all_enabled();
    /*
    if (_client.isRunning() == false) {
        set_minner_button_text(
          _message.thanks_for_help
          // 'Gracias por tu ayuda. Vuelve a clickar para dejar de enviarnos Moneros.'
        );
        // ~ document.getElementById(minnerid).innerHTML = 'Gracias por tu ayuda. Vuelve a clickar para dejar de crear Moneros.';
        _start_minning();
        _minner_type = 0;
        _show_tables = true;
        update_buttons_for_show();
    } else {
        _stop_minning();
        _show_tables = false;
        _minner_type = undefined;
        update_buttons_for_show();
        set_minner_button_text_accept();
        // ~ document.getElementById(minnerid).innerHTML = 'Acepto generar Moneros a Pronia durante esta visita.';
    }
    */
  }
  mpublic.accept_minner = _accept_minner;

  /*
   * update table button for show table information
   */
  function update_miner_table_button_with(id){
    var _msg = _message.see_more_forecast;
    // var _msg = 'Ver pronósticos restantes.';
    // var id = _tableids[i];
    if (_show_tables == false) {
      var _tt = _table_times[id][0];
      // if (_minner_time > 0) {
      if (_tt > 0 && _client) {
        _hs = _client.getTotalHashes(true);
        if (_production) {
          _msg = [_message.production.thanks_timer, _tt, _message.seconds].join(' ');
          // _msg = `${_message.production.thanks_timer} ${_tt} ${_message.seconds}`;
          // _msg = `${_message.production.thanks_timer} ${_minner_time} ${_message.seconds}`;
          // _msg = _message.production.thanks_timer;
          // _msg = `Gracias por tu ayuda. Se generarán moneros durante ${_minner_time} segundos.`;
        } else {
          _msg = [_message.development.thanks_timer, _tt, _message.seconds, _message.hashes, _hs, '.'].join(' ');
          // _msg = `${_message.development.thanks_timer} ${_tt} ${_message.seconds} ${_message.hashes} ${_hs}.`;
          // _msg = `${_message.development.thanks_timer} ${_minner_time} ${_message.seconds} ${_message.hashes} ${_hs}.`;
          // _msg = _message.development.thanks_timer;
          // _msg = `Gracias por tu ayuda. Se generarán moneros durante ${_minner_time} segundos. Hashes: ${_hs}.`;
        }
      } else {
        _msg = _message.accept_minner_for_table;
        // _msg = 'Acepto generar Moneros para ver los pronósticos de esta tabla.'
      }
    } else if (_client) {
      if (_client.isRunning() == true && _minner_type == 1) {
        _msg = [_message.production.thanks_timer, _minner_time, _message.seconds].join(' ');
        // _msg = `${_message.production.thanks_timer} ${_minner_time} ${_message.seconds}`;
        // _msg = _message.production.thanks_timer;
        // _msg = `Gracias por tu ayuda. Se generarán moneros durante ${_minner_time} segundos.`
      } else if (_client.isRunning() == true) {
        if (_table_showing.indexOf(id) == -1) {
          _msg = _message.see_more_forecast;
          // _msg = 'Ver pronósticos restantes.';
        } else {
          _msg = _message.hide_forecast;
          // _msg = 'Ocultar pronósticos.';
        }
        // _msg = 'Ver pronósticos restantes.';
      } else {
        _msg = _message.accept_minner_for_table;
        // _msg = 'Acepto generar Moneros para ver los pronósticos de esta tabla.'
      }
    // _console(_msg, id, _table_showing, _tableids);
    } else {
      if (_table_showing.indexOf(id) == -1) {
        _msg = _message.see_more_forecast;
        // _msg = 'Ver pronósticos restantes.';
      } else {
        _msg = _message.hide_forecast;
        // _msg = 'Ocultar pronósticos.';
      }
    }
    // if ()
    set_minner_button_text_with_id(
      'b' + id,
      // 'b' + _tableids[i],
      _msg
      );
  }

  /*
   * update buttons for show table information
   */
  /*
  function update_buttons_for_show() {
    var i, _id;
    // _console(_tableids);
    for (i = 0; i < _tableids.length; i++) {
      _id = _tableids[i];
      update_miner_table_button_with(_id);
    }
  }
  */

  /*
  function show_table_id(id) {
    var _obj = document.getElementById(id), _hid = 'hidden';
    // _console(_obj.classList);
    if (_obj.classList.contains(_hid)) {
      _obj.classList.toggle(_hid);
    }
  }
  */

  /*
  function hide_table_id(id) {
    var _obj = document.getElementById(id), _hid = 'hidden';
    if (!_obj.classList.contains(_hid)) {
      _obj.classList.toggle(_hid);
    }
    // document.getElementById(id).class = 'hidden';
  }
  */

  /*
  function show_hide_table_id(id) {
    var _obj = document.getElementById(id), _hid = 'hidden';
    // _console(_obj.classList);
    // if (_obj.classList.toggle(_hid) != )
    _obj.classList.toggle(_hid);
    // if (_obj.class == 'hidden') {
    //   _obj.class = '';
    // } else {
    //   _obj.class = 'hidden';
    // }
  }
  */

  /*
   * minner to show table content
   */
  // var _minner_time = 0, _time_line = 8*2, _min_accepted_hashes = 2;

  function check_minner_web_view(){

  }

  function check_minner_table_view(){
    // only check visible tables
    var i, _id;
    // _console(_tableids);
    for (i = 0; i < _table_showing.length; i++) {
      _id = _table_showing[i];
      check_minner_table_with(_id);
      // _console(_table_times[_id][0]);
    }
  }

  function check_minner_table_with(id){
    // var _in = _table_showing.indexOf(id);
    // var _tt = _table_times[id];
    // _console(_table_times);

    // if (_client.isRunning() && _client.getTotalHashes() < _min_hashes){
    //   _minner_total_time += _time_line;
    //   _minner_time += _time_line;
    // }
    _table_times[id][0] -= _time_line;
    // _minner_time -= _time_line;
    // if (_client.getAcceptedHashes() < _min_accepted_hashes && _minner_time <= 0){
    //   _minner_time += _time_line;
    // }
    // if (_minner_time <= 0) {
    if (_table_times[id][0] <= 0) {
      _table_times[id][0] = 0;
      // _minner_time = 0;
      // if (_minner_type == 1) {
      // stop minner
      _stop_minning();
      // _client.stop();
      update_miner_table_button_with(id);
      // update_buttons_for_show();
      _minner_type = undefined;
      // }
    } else {
      update_miner_table_button_with(id);
      // update_buttons_for_show();
    }
  }

  function check_minner_state() {
    // if (_minner_type == 0){
      // minner in visit
    //   check_minner_web_view();
    // }
    if (_minner_type == 1) {
      // minner in table view
      check_minner_table_view();
    }
    // _console(_minner_total_time, _minner_time, _client.isRunning(), _client.getAcceptedHashes(), _client.getTotalHashes(), _cook);
  }

  /*
  function table_is_visible(id){
    return _table_showing.indexOf(id) != -1;
  }
  */

  function _accept_minner_for_show(tableid) {
    _tables.minner_table_id(tableid);
  }
  mpublic.accept_minner_for_show = _accept_minner_for_show;
  /*
  mpublic.accept_minner_for_show = function(tableid, lines) {
    _console(tableid, lines);
    if (_client.isRunning() == false) {
        // ~ document.getElementById(minnerid).innerHTML = 'Gracias por tu ayuda. Vuelve a clickar para dejar de crear Moneros.';
        if (_minner_type == 1 || _minner_type == undefined) {
          _table_showing.push(tableid);
          _start_minning();
          // _client.start();
          _minner_type = 1;
          // _minner_time += lines * _time_line;
          var _tt = lines * _time_line;
          _table_times[tableid] = [_tt, lines]
          set_minner_button_text_with_id(
              'b' + tableid,
              `Gracias por tu ayuda. Se generarán moneros durante ${_tt} segundos.`
              );
        }
        // show_table_id(tableid);
    } else {
      if (_minner_type == 1) {
        // if (!table_is_visible(tableid)) {
        //   _minner_time += lines * _time_line;
        // }
        _tt = _table_times[tableid][0];
        set_minner_button_text_with_id(
          'b' + tableid,
          `Gracias por tu ayuda. Se generarán moneros durante ${_tt} segundos.`
          );
      } else {
        _table_showing.push(tableid);
        update_buttons_for_show();
      }

    }
    if (table_is_visible(tableid)) {
      show_table_id(tableid);
      // show_hide_table_id(tableid);
    }
  }
  */

  mpublic.add_table_id = _bmt.add_table_id;
  // /*
  //  * add table ids to tables list and update buttons state, if not in list.
  //  */
  // function _add_table_id(id, lines){
  //   // _console(_tables.length);
  //   // if (_tids.indexOf(id) == -1) {
  //   //   _tids.push(id);
  //   // }
  //   _tables.create_with_id(id, lines);
  //   // _tables.update();
  //   /*
  //   if (_tableids.indexOf(id) == -1) {
  //     _tableids.push(id);
  //     _table_times[id] = [0, 0];
  //     update_buttons_for_show();
  //   }
  //   */
  // }
  // mpublic.add_table_id = _add_table_id;

  function _getset_cookie_minner(){
    _cook = new BlackMostrosCookie();
    // _cook = getCookie(_cn.name);
    // _console(_cook);
    // if (_cook == undefined) {
    if (_cook.get(_cook.cn.name) == undefined) {
      _cook.create(_cook.cn.name, 0, 1);
      // createCookie(_cook.cn.name, 0, 1);
      // _cook = getCookie(_cook.cn.name);
    }
  }

  // function _toString(){
  //   return `Is running/in visit: ${_run}/${_minning_in_visit}. Client running: ${_client.isRunning()}. Acepted/Total hashes: ${_ah}/${_th}.`;
  // }
  // mpublic.toString = _toString;
  function _get_client(){
    return _client;
  };
  mpublic.get_client = _get_client;

  function _init(){

    /*
     *
     *
     * set visit minner button before load client load
     *
     * config miner tools when client is loaded
     *
     */
    if (enable) {
      set_visit_minner_button();

      // ~ _wa = await when_available();
      when_available('Client', function() {

        // call server for miner preferences
        _pronia.get_miner_data().then(function(result){
          // data can be undefined
          if (result.data) {
            _mid = result.data.id;
            _throttle = result.data.throttle;
            // ~ console.log('ads', result.data.ads);
            if (result.data.ads == true) {
              _ads = 1;
            } else {
              _ads = 0;
            };
            if (result.data.coin != null){
              _coin = result.data.coin;
            };
            // ~ console.log(result);
            // ~ console.log('pronia:', result, _mid, _throttle, _ads);

            _getset_cookie_minner();

            // init tables
            _tables.init();

            _client = new Minner(_mid, _throttle);
            _client.init();

            // set client in tables
            _bmt.set_client(_client);

            // ~ set_visit_minner_button();

            /*
            set_minner_button_text_accept();

            window.setInterval(function(){
              /// call your function here
              check_minner_state();
            }, _time_line * 1000);

            update_buttons_for_show();
            */

            // start mining if timeamount is not 0
            if (_cook.get(_cook.cn.minertime > 0)) {
              _cook.create(_cook.cn.name, 1, 1);
            }
            // start minning if cookie is 1 and enable
            if (_cook.get(_cook.cn.name) == 1 & enable) {
              _minner_button.click();
              // mpublic.accept_minner();
            }

            console_if_debug('Minner ready...');
            // _console(_tables);
            // _console(_tables, _tids);
            // ~ console.log('Minner ready...');
          };

        });

      });

    } else {
        // init tables
        _tables.init();
        console_if_debug('Minner disabled...');
    }

  }
  mpublic.init = _init;

  return mpublic;

});

export {
  BlackMostrosMinner,
  };
